/* NOVA STARLIGHT theme — cart drawer + quick view, vanilla JS, no build step */
(function () {
  "use strict";

  var moneyFormat = window.themeMoneyFormat || "£{{amount}}";

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace("{{amount}}", amount).replace("{{ amount }}", amount);
  }

  /* ---------------- Responsive navigation ---------------- */
  var menuTrigger = document.querySelector("[data-menu-trigger]");
  var menuClose = document.querySelector("[data-menu-close]");
  var menuIcon = document.querySelector("[data-menu-icon]");
  var menuButton = menuTrigger ? menuTrigger.querySelector("[data-menu-toggle]") : null;

  function setMenuOpen(open) {
    if (!menuTrigger) return;
    menuTrigger.classList.toggle("is-open", open);
    if (menuButton) menuButton.setAttribute("aria-expanded", open ? "true" : "false");

  }

  if (menuClose) {
    menuClose.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      setMenuOpen(false);
    });
  }

  if (menuButton) {
    menuButton.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      setMenuOpen(!(menuTrigger && menuTrigger.classList.contains("is-open")));
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartOverlay = document.querySelector("[data-cart-overlay]");
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var cartBody = document.querySelector("[data-cart-body]");
  var cartSubtotal = document.querySelector("[data-cart-subtotal]");
  var cartCountEls = document.querySelectorAll("[data-cart-count]");
  var cartCheckoutBtn = document.querySelector("[data-cart-checkout]");

  function openCart() {
    document.body.classList.add("ht-body-lock");
    if (cartOverlay) cartOverlay.classList.add("is-open");
    if (cartDrawer) cartDrawer.classList.add("is-open");
  }

  function closeCart() {
    document.body.classList.remove("ht-body-lock");
    if (cartOverlay) cartOverlay.classList.remove("is-open");
    if (cartDrawer) cartDrawer.classList.remove("is-open");
  }

  function updateCartCount(n) {
    cartCountEls.forEach(function (el) {
      el.textContent = n;
    });
  }

  function cartItemTemplate(item) {
    var img = item.image
      ? '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
      : "";
    var variantMeta = item.variant_title ? item.variant_title.toUpperCase() : "";
    return (
      '<li class="ht-cart__item" data-line-key="' + item.key + '">' +
        '<div class="ht-cart__thumb">' + img + "</div>" +
        '<div class="ht-cart__info">' +
          '<div class="ht-cart__row-top">' +
            "<div>" +
              '<p class="ht-cart__title">' + escapeHtml(item.product_title) + "</p>" +
              (variantMeta ? '<p class="ht-cart__meta">' + escapeHtml(variantMeta) + "</p>" : "") +
            "</div>" +
            '<button class="ht-cart__remove" data-cart-remove aria-label="Remove item">' + trashIcon() + "</button>" +
          "</div>" +
          '<div class="ht-cart__row-bottom">' +
            '<div class="ht-cart__qty">' +
              '<button type="button" data-cart-decrease aria-label="Decrease">' + minusIcon() + "</button>" +
              '<span>' + item.quantity + "</span>" +
              '<button type="button" data-cart-increase aria-label="Increase">' + plusIcon() + "</button>" +
            "</div>" +
            '<span class="ht-cart__line-price">' + formatMoney(item.final_line_price) + "</span>" +
          "</div>" +
        "</div>" +
      "</li>"
    );
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!cartBody) return;

    if (!cart.items.length) {
      cartBody.innerHTML = '<p class="ht-cart__empty">YOUR CART IS EMPTY</p>';
    } else {
      cartBody.innerHTML =
        '<ul class="ht-cart__list">' + cart.items.map(cartItemTemplate).join("") + "</ul>";
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    if (cartCheckoutBtn) cartCheckoutBtn.disabled = cart.items.length === 0;
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  if (cartBody) {
    cartBody.addEventListener("click", function (e) {
      var li = e.target.closest("[data-line-key]");
      if (!li) return;
      var key = li.getAttribute("data-line-key");
      if (e.target.closest("[data-cart-remove]")) {
        changeLine(key, 0);
      } else if (e.target.closest("[data-cart-increase]")) {
        var current = parseInt(li.querySelector(".ht-cart__qty span").textContent, 10);
        changeLine(key, current + 1);
      } else if (e.target.closest("[data-cart-decrease]")) {
        var cur = parseInt(li.querySelector(".ht-cart__qty span").textContent, 10);
        changeLine(key, Math.max(0, cur - 1));
      }
    });
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      setMenuOpen(false);
      fetchCart();
      openCart();
    });
  });

  /* Close the mobile navigation after a link is selected. */
  document.querySelectorAll(".ht-nav-menu__link").forEach(function (link) {
    link.addEventListener("click", function () {
      if (window.matchMedia("(max-width: 639px)").matches) setMenuOpen(false);
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (btn) {
    btn.addEventListener("click", closeCart);
  });
  if (cartOverlay) cartOverlay.addEventListener("click", closeCart);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  if (cartCheckoutBtn) {
    cartCheckoutBtn.addEventListener("click", function () {
      if (cartCheckoutBtn.disabled) return;
      window.location.href = "/checkout";
    });
  }

  /* ---------------- Quick view ---------------- */
  var qvOverlay = document.querySelector("[data-qv-overlay]");
  var qvBody = document.querySelector("[data-qv-body]");
  var currentProduct = null;
  var currentImageIndex = 0;
  var selectedSize = null;
  var selectedColor = null;

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function trashIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>';
  }
  function minusIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>';
  }
  function plusIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>';
  }
  function closeIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  }

  /* Shopify's product JSON can expose options as strings, or (in newer
     contexts) as option objects. Normalize both shapes so the quick view
     never loses Size/Color controls. */
  function normalizedOptionNames(product) {
    if (Array.isArray(product.options)) {
      return product.options.map(function (option) {
        return typeof option === "string" ? option : (option && (option.name || option.label)) || "";
      });
    }
    if (Array.isArray(product.options_with_values)) {
      return product.options_with_values.map(function (option) {
        return typeof option === "string" ? option : (option && (option.name || option.label)) || "";
      });
    }
    return [];
  }

  function findOptionIndex(product, pattern) {
    var names = normalizedOptionNames(product);
    for (var i = 0; i < names.length; i++) {
      if (pattern.test(names[i])) return i;
    }
    return -1;
  }

  function findSizeOptionIndex(product) {
    return findOptionIndex(product, /size|fit/i);
  }

  function findColorOptionIndex(product) {
    return findOptionIndex(product, /colou?r|colourway|shade|finish/i);
  }

  function optionValuesFor(product, index) {
    var seen = {};
    var values = [];
    if (index < 0 || !Array.isArray(product.variants)) return values;

    product.variants.forEach(function (v) {
      var val = [v.option1, v.option2, v.option3][index];
      if (val && val !== "Default Title" && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });

    /* Prefer Shopify's explicit option values when available, because this
       can include values that aren't represented by the first variant. */
    var explicit = Array.isArray(product.options_with_values) ? product.options_with_values[index] : null;
    if (explicit && Array.isArray(explicit.values)) {
      explicit.values.forEach(function (value) {
        var name = typeof value === "string" ? value : (value && value.name);
        if (name && name !== "Default Title" && !seen[name]) {
          seen[name] = true;
          values.push(name);
        }
      });
    }
    return values;
  }

  function variantForSelections(product, sizeIndex, size, colorIndex, color) {
    return product.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3];
      if (sizeIndex >= 0 && opts[sizeIndex] !== size) return false;
      if (colorIndex >= 0 && opts[colorIndex] !== color) return false;
      return true;
    });
  }

  function variantImage(variant) {
    if (!variant || !variant.featured_image) return null;
    return variant.featured_image.src || variant.featured_image.url || variant.featured_image;
  }

  function renderQuickView(product) {
    currentProduct = product;
    currentImageIndex = 0;
    selectedSize = null;
    selectedColor = null;

    var sizeIndex = findSizeOptionIndex(product);
    var colorIndex = findColorOptionIndex(product);
    var sizes = optionValuesFor(product, sizeIndex);
    var colors = optionValuesFor(product, colorIndex);
    var images = product.images && product.images.length ? product.images : [product.featured_image];
    var badge = "";
    if (product.tags.some(function (t) { return /new/i.test(t); })) badge = "NEW";
    else if (product.compare_at_price_max > product.price_min) badge = "SALE";

    var html =
      '<div class="ht-qv-media" data-qv-media>' +
        (badge ? '<span class="ht-qv-badge">' + badge + "</span>" : "") +
        '<img src="' + images[0] + '" alt="' + escapeHtml(product.title) + '" data-qv-image>' +
        (images.length > 1
          ? '<div class="ht-qv-views" data-qv-views>' +
              images.map(function (src, i) {
                return '<button type="button" class="ht-qv-view-btn' + (i === 0 ? " is-active" : "") + '" data-qv-view-btn data-index="' + i + '">' + (i === 0 ? "FRONT" : i === 1 ? "BACK" : "VIEW " + (i + 1)) + "</button>";
              }).join("") +
              "</div>"
          : "") +
      "</div>" +
      '<div class="ht-qv-details">' +
        '<div>' +
          '<p class="ht-qv-brand">' + escapeHtml(window.themeShopName || "") + "</p>" +
          "<h2 class=\"ht-qv-title\">" + escapeHtml(product.title) + "</h2>" +
          '<p class="ht-qv-colour" data-qv-selected-colour>' + (colorIndex >= 0 ? 'SELECT A COLOUR' : escapeHtml(product.vendor || "").toUpperCase()) + "</p>" +
        "</div>" +
        '<p class="ht-qv-price">' +
          (product.compare_at_price_max > product.price_min ? "<s>" + formatMoney(product.compare_at_price_max) + "</s>" : "") +
          formatMoney(product.price_min) +
        "</p>" +
        '<p class="ht-qv-desc">' + stripHtml(product.description).slice(0, 320) + "</p>" +
        (sizes.length ?
          '<div><div class="ht-qv-size-row"><span class="ht-qv-size-label">SIZE</span><span class="ht-qv-warn" data-qv-size-warn hidden>SELECT A SIZE</span></div>' +
          '<div class="ht-qv-sizes" data-qv-sizes>' +
          sizes.map(function (s) {
            var v = variantForSelections(product, sizeIndex, s, colorIndex, colors.length ? colors[0] : null);
            var disabled = v && !v.available ? " disabled" : "";
            return '<button type="button" class="ht-qv-size-btn" data-qv-size="' + escapeHtml(s) + '"' + disabled + '>' + escapeHtml(s) + '</button>';
          }).join("") + '</div></div>' : "") +
        (colors.length ?
          '<div><div class="ht-qv-size-row"><span class="ht-qv-size-label">COLOUR</span><span class="ht-qv-warn" data-qv-color-warn hidden>SELECT A COLOUR</span></div>' +
          '<div class="ht-qv-colors" data-qv-colors>' +
          colors.map(function (c) {
            var v = variantForSelections(product, sizeIndex, sizes.length ? sizes[0] : null, colorIndex, c);
            var img = variantImage(v);
            return '<button type="button" class="ht-qv-color-btn" data-qv-color="' + escapeHtml(c) + '" aria-label="' + escapeHtml(c) + '" title="' + escapeHtml(c) + '">' + escapeHtml(c) + '</button>';
          }).join("") + '</div></div>' : "") +
        '<button type="button" class="ht-btn" data-qv-add-to-cart>ADD TO CART</button>' +
      "</div>";

    qvBody.innerHTML = html;
    qvBody.setAttribute("data-size-index", sizeIndex);
    qvBody.setAttribute("data-color-index", colorIndex);
  }

  function stripHtml(html) {
    var tmp = document.createElement("div");
    tmp.innerHTML = html || "";
    return tmp.textContent || tmp.innerText || "";
  }

  function openQuickView(handle) {
    fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        renderQuickView(product);
        document.body.classList.add("ht-body-lock");
        qvOverlay.classList.add("is-open");
      });
  }

  function closeQuickView() {
    document.body.classList.remove("ht-body-lock");
    if (qvOverlay) qvOverlay.classList.remove("is-open");
  }

  document.querySelectorAll("[data-qv-trigger]").forEach(function (el) {
    el.addEventListener("click", function () {
      var handle = el.getAttribute("data-qv-trigger");
      openQuickView(handle);
    });
  });

  if (qvOverlay) {
    qvOverlay.addEventListener("click", function (e) {
      if (e.target === qvOverlay) closeQuickView();
    });
  }

  document.querySelectorAll("[data-qv-close]").forEach(function (btn) {
    btn.addEventListener("click", closeQuickView);
  });

  if (qvBody) {
    qvBody.addEventListener("click", function (e) {
      var viewBtn = e.target.closest("[data-qv-view-btn]");
      if (viewBtn) {
        var idx = parseInt(viewBtn.getAttribute("data-index"), 10);
        currentImageIndex = idx;
        var img = qvBody.querySelector("[data-qv-image]");
        var images = currentProduct.images && currentProduct.images.length ? currentProduct.images : [currentProduct.featured_image];
        img.src = images[idx];
        qvBody.querySelectorAll("[data-qv-view-btn]").forEach(function (b) {
          b.classList.toggle("is-active", b === viewBtn);
        });
        return;
      }

      var sizeBtn = e.target.closest("[data-qv-size]");
      if (sizeBtn) {
        if (sizeBtn.disabled) return;
        selectedSize = sizeBtn.getAttribute("data-qv-size");
        qvBody.querySelectorAll("[data-qv-size]").forEach(function (b) { b.classList.toggle("is-selected", b === sizeBtn); });
        var sizeWarn = qvBody.querySelector("[data-qv-size-warn]");
        if (sizeWarn) sizeWarn.hidden = true;
        return;
      }

      var colorBtn = e.target.closest("[data-qv-color]");
      if (colorBtn) {
        if (colorBtn.disabled) return;
        selectedColor = colorBtn.getAttribute("data-qv-color");
        qvBody.querySelectorAll("[data-qv-color]").forEach(function (b) { b.classList.toggle("is-selected", b === colorBtn); });
        var colorLabel = qvBody.querySelector("[data-qv-selected-colour]");
        if (colorLabel) colorLabel.textContent = selectedColor.toUpperCase();
        var colorWarn = qvBody.querySelector("[data-qv-color-warn]");
        if (colorWarn) colorWarn.hidden = true;
        var sizeIndexForColor = parseInt(qvBody.getAttribute("data-size-index"), 10);
        var colorIndexForColor = parseInt(qvBody.getAttribute("data-color-index"), 10);
        var chosenVariant = variantForSelections(currentProduct, sizeIndexForColor, selectedSize || null, colorIndexForColor, selectedColor);
        var chosenImage = variantImage(chosenVariant);
        if (chosenImage) {
          var img = qvBody.querySelector("[data-qv-image]");
          if (img) img.src = chosenImage;
        }
        return;
      }

      var addBtn = e.target.closest("[data-qv-add-to-cart]");
      if (addBtn) {
        var sizeIndex = parseInt(qvBody.getAttribute("data-size-index"), 10);
        var colorIndex = parseInt(qvBody.getAttribute("data-color-index"), 10);
        if (sizeIndex >= 0 && !selectedSize) {
          var warnEl = qvBody.querySelector("[data-qv-size-warn]");
          if (warnEl) warnEl.hidden = false;
          return;
        }
        if (colorIndex >= 0 && !selectedColor) {
          var colorWarnEl = qvBody.querySelector("[data-qv-color-warn]");
          if (colorWarnEl) colorWarnEl.hidden = false;
          return;
        }
        var variant = variantForSelections(currentProduct, sizeIndex, selectedSize, colorIndex, selectedColor);
        if (!variant || !variant.available) return;
        addBtn.disabled = true;
        addToCart(variant.id, 1)
          .then(function () {
            closeQuickView();
            return fetchCart();
          })
          .then(openCart)
          .catch(function () {
            addBtn.disabled = false;
          });
      }
    });
  }

  /* Mobile homepage: controlled one-product-at-a-time scrolling. */
  (function setupMobileProductPaging() {
    var field = document.querySelector('.ht-field');
    if (!field) return;
    var touchStartY = null;
    var locked = false;
    var lockTimer = null;

    function isMobile() {
      return window.matchMedia('(max-width: 639px)').matches;
    }

    function products() {
      return Array.prototype.slice.call(field.querySelectorAll('.ht-float'));
    }

    function currentIndex() {
      var items = products();
      if (!items.length) return 0;
      var top = field.scrollTop;
      var best = 0;
      var distance = Infinity;
      items.forEach(function (item, i) {
        var d = Math.abs(item.offsetTop - top);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }

    function goTo(index) {
      if (!isMobile() || locked) return;
      var items = products();
      if (!items.length) return;
      index = Math.max(0, Math.min(index, items.length - 1));
      locked = true;
      field.scrollTo({ top: items[index].offsetTop, behavior: 'smooth' });
      clearTimeout(lockTimer);
      lockTimer = setTimeout(function () { locked = false; }, 720);
    }

    field.addEventListener('wheel', function (e) {
      if (!isMobile()) return;
      e.preventDefault();
      if (locked) return;
      if (Math.abs(e.deltaY) < 4) return;
      goTo(currentIndex() + (e.deltaY > 0 ? 1 : -1));
    }, { passive: false });

    field.addEventListener('touchstart', function (e) {
      if (!isMobile() || !e.touches.length) return;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    field.addEventListener('touchend', function (e) {
      if (!isMobile() || touchStartY === null || locked) return;
      var endY = e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientY : touchStartY;
      var delta = touchStartY - endY;
      touchStartY = null;
      if (Math.abs(delta) < 35) return;
      goTo(currentIndex() + (delta > 0 ? 1 : -1));
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (!isMobile()) { locked = false; return; }
      var i = currentIndex();
      var items = products();
      if (items[i]) field.scrollTop = items[i].offsetTop;
    });
  })();

  /* preload cart count on first paint */
  fetchCart();
})();
